import React, { Component } from 'react';

// Default setup
import Navigation from './layout/navigation/Navigation';
import Footer from './layout/footer/Footer';
import HeroFirstItem from './layout/hero/HeroFirstItem';

import ProjectCard1x1 from './layout/portfolio/ProjectCard1x1';
import ProjectCard1x2 from './layout/portfolio/ProjectCard1x2';
import ProjectInfo from './layout/portfolio/ProjectInfo';

const content =
  {
    title: "Testing :3",
    diciplines: ["Code", "Illustration"],
    pagelink: ""
  };

class Work extends Component {
  render () {
    return(
      <div>
        <Navigation />
        <HeroFirstItem/>
        <ProjectInfo />
        <h1>About my work.</h1>
          <div className="container">
              <ProjectCard1x2 />
                <div className="grid">

              <ProjectCard1x1 title={content.title} diciplines={content.diciplines} pagelink={content.diciplines}/>
            </div>
          </div>
        <Footer/>
      </div>
    );
  }
}

export default Work;



// WEBPACK FOOTER //
// ./src/Work.js